import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, map } from "rxjs";
import { AppSettings } from "../../config/config";
import { apiConstants } from "../constant/apiConstant";
apiConstants;

@Injectable({
  providedIn: "root",
})
export class BroadcastService {
  constructor(private http: HttpClient) {}

  private URL_V3 = AppSettings.API_ENDPOINT_V3;
  private language = "en";
  private params = new HttpParams().set("lang", this.language);
  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem("usertoken")||"";
    return new HttpHeaders({
      token: token,
    });
  }

  getAcademicYears() {
    return this.http
      .get(this.URL_V3 + apiConstants.getAcademicYearsAPI, {
        headers: this.getHeaders(),
        params: this.params,
      })
      .pipe(map((res) => res));
  }

  getBroadcastType(extraHeaders?: HttpHeaders) {
    return this.http
      .get(this.URL_V3 + apiConstants.getBroadcastTypeAPI, {
        headers: extraHeaders || this.getHeaders(),
        params: this.params,
      })
      .pipe(map((res) => res));
  }

  getBroadcastReceiverListV2(academicId) {
    const query_params = {
      lang: "en",
      academicId: academicId,
    };
    return this.http
      .get(this.URL_V3 + apiConstants.getBroadcastReceiverListV2API, {
        headers: this.getHeaders(),
        params: query_params,
      })
      .pipe(map((res) => res));
  }

  createBroadcastService(body: any, media: File | File[] | null, extraHeaders?: HttpHeaders) {
    const form = new FormData();
    for (const key in body) {
      if (body.hasOwnProperty(key)) {
        form.append(key, body[key]);
      }
    }
    if (Array.isArray(media)) {
      media.forEach((file) => {
        if (file) {
          form.append("broadcastMedia", file, file.name);
        }
      });
    } else if (media) {
      form.append("broadcastMedia", media, media.name);
    } else {
      form.append("broadcastMedia", null);
    }
    const headers = extraHeaders || this.getHeaders();
    const url = this.URL_V3 + apiConstants.createBroadcastAPI;
    return this.http.post(url, form, { headers }).pipe(map((res) => res));
  }

  createBroadcastServiceV2(body: any, media: File[]) {
    const form = new FormData();
    for (const key in body) {
      if (body.hasOwnProperty(key)) {
        form.append(key, body[key]);
      }
    }
    (media || []).forEach((file) => {
      if (file) {
        form.append("broadcastMedia", file, file.name);
      }
    });
    const headers = this.getHeaders();
    const url = this.URL_V3 + apiConstants.createBroadcastV2API;
    return this.http.post(url, form, { headers }).pipe(map((res) => res));
  }

  getBroadcast(academicId, receiverId, currentPage: number,
    pageSize: number) {
    const headers= this.getHeaders();
    const url = this.URL_V3 + apiConstants.getBroadcastAPI;
    const query_params = {
      "lang":"en",
      "academicId":academicId,
      "broadcastReceiverId": receiverId ?? '',
      "pageNumber":currentPage,
      "pageLimit":pageSize
    }
    return this.http.get(url, {
      headers: headers,
      params: query_params
    }).pipe((res)=>res);
  }

  getBroadcastMessagesV2(
    academicId,
    receiverType,
    search,
    startDate,
    endDate,
    pageNumber: number,
    pageLimit: number
  ) {
    const headers = this.getHeaders();
    const url = this.URL_V3 + apiConstants.getBroadcastMessagesV2API;
    const body = {
      lang: "en",
      academicId: academicId,
      receiverType: receiverType ?? null,
      search: search ?? null,
      startDate: startDate ?? null,
      endDate: endDate ?? null,
      pageNumber: pageNumber,
      pageLimit: pageLimit,
    };
    return this.http.post(url, body, { headers }).pipe(map((res) => res));
  }

  getBroadcastReceiverDetailList(broadcastId: number, pageNumber: number, pageLimit: number, search?: string | null) {
    const headers = this.getHeaders();
    const url = this.URL_V3 + apiConstants.getBroadcastReceiverDetailListAPI;
    const body = {
      lang: "en",
      broadcastId: broadcastId,
      pageNumber: pageNumber,
      pageLimit: pageLimit,
      search: search || null,
    };
    return this.http.post(url, body, { headers }).pipe(map((res) => res));
  }

}
